<div class="page-content">
  <h2 class="category-tittle">{{(categoryData$ | async)?.categoriesTitle}}</h2>
  <ng-container *ngFor="let content of (categoryData$ | async)?.data">
    <h3 class="sub-title" *ngIf="content.type === blockType.TITLE" [innerHTML]="content.data"></h3>
    <p *ngIf="content.type === blockType.TEXT" [innerHTML]="content.data"></p>
    <img *ngIf="content.type === blockType.IMG" [src]="'assets/img/' + content.data" [ngClass]="{
      'large': content.imgSize === imgSize.L,
      'medium': content.imgSize === imgSize.M,
      'small': content.imgSize === imgSize.S,
      'extra-small': content.imgSize === imgSize.XS
    }"
         [alt]="(categoryData$ | async).categoriesUrl">
    <ul *ngIf="content.type === blockType.LIST_DOTS">
      <li *ngFor="let li of content.data" [innerHTML]="li"></li>
    </ul>
    <ol *ngIf="content.type === blockType.LIST_NUMBERS" start="{{content.startAt > 0 ? content.startAt : 1}}">
      <li *ngFor="let li of content.data" [innerHTML]="li"></li>
    </ol>
    <div *ngIf="content.type === blockType.TABLE" class="d-flex flex-column double-table">
      <div *ngFor="let li of content.data" class="d-flex w-100 row">
        <div *ngFor="let l of li" [innerHTML]="l" class="cell"></div>
      </div>
    </div>
    <iframe *ngIf="content.type === blockType.VIDEO"
            width="667" height="480"
            [src]="trustResourceUrl(content.data)" style="border: none" allow="encrypted-media" allowfullscreen></iframe>
  </ng-container>
</div>
<div class="d-flex justify-content-between footer-navigation">
  <div>
    <a *ngIf="footerNavigation[0]" class="footer-link btn btn-outline-blue-dark btn-sm"
       [routerLink]="['../', footerNavigation[0].categoriesUrl]"><i class="fa fa-arrow-left" aria-hidden="true"></i> {{footerNavigation[0].categoriesTitle}}</a>
  </div>
  <div>
    <a *ngIf="footerNavigation[1]" class="footer-link btn-custom btn-custom-blue-dark btn-sm"
       [routerLink]="['../', footerNavigation[1].categoriesUrl]">{{footerNavigation[1].categoriesTitle}} <i class="fa fa-arrow-right" aria-hidden="true"></i></a>
  </div>
</div>
